import { cn } from '@module/lib/utils';
import useModalStore from '@module/stores/useModalStore';
import type React from 'react';
import { useEffect } from 'react';

interface Props extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  escDisabled?: boolean;
}

function CloseButton({ onClick, className, escDisabled, ...props }: Props) {
  const { popModal } = useModalStore();

  useEffect(() => {
    if (escDisabled) return;
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        popModal();
      }
    };
    document.addEventListener('keydown', handleKeyDown);
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [popModal]);

  const handleClick = onClick || popModal;

  return (
    <button
      {...props}
      onClick={handleClick}
      className={cn(
        'relative h-[30px] w-[30px] before:absolute before:top-[50%] before:left-[50%] before:h-[2px] before:w-[19px] before:rotate-[-45deg] before:rounded-[2px] before:bg-colorBg05 before:content-[""] after:absolute after:top-[50%] after:left-[50%] after:h-[2px] after:w-[19px] after:rotate-45 after:rounded-[2px] after:bg-colorBg05 after:content-[""]',
        className,
      )}
    />
  );
}

export default CloseButton;
